import type {FC} from 'react';
import {MdOutlineBookmark, MdOutlineBookmarkBorder} from 'react-icons/md';
import {COLOR_BLACK_3, COLOR_SUB} from '../../../config/constants/colorCodes';

type Props = {
  count: string;
  isClipped: boolean;
  handleUpdate: () => Promise<void>;
};

/**
 * リデザイン前のクリップボタン
 */
export const ClipButtonTypeA: FC<Props> = ({
  count,
  isClipped,
  handleUpdate,
}) => (
  <button
    type="button"
    onClick={async (e) => {
      e.preventDefault();
      e.stopPropagation();
      await handleUpdate();
    }}
  >
    <div className="flex items-center">
      {isClipped ? (
        <MdOutlineBookmark color={COLOR_SUB} size="32px" />
      ) : (
        <MdOutlineBookmarkBorder color={COLOR_BLACK_3} size="32px" />
      )}
      <div className="text-xs text-black-2">{count}</div>
    </div>
  </button>
);
